<template lang="pug">
div(class='step_time__container')
  div(
    class='step_time__element step_time__element--full'
    v-for='step in steps'
    v-if='step % 2 === 0'
    :style='{ left: getShift(step) + "%" }')
    div(class='step_time__label') {{ getDate(startTime + (300000 * 24 * step)) }}
  div(
    class='step_time__element step_time__element--halt'
    v-else
    :style='{ left: getShift(step) + "%" }')
</template>

<script>
import range from "lodash/range";

export default {
  name: "StepTime",
  props: {
    startTime: {
      type: Number,
      default: () => new Date().setHours(0, 0, 0, 0),
    },
  },
  data() {
    return {
      steps: range(13),
    };
  },
  methods: {
    /**
     * Return the shift in format float
     * @param {Number} step
     */
    getShift(step) {
      return (100 / 12) * step;
    },

    /**
     * Return Date string in format "HH:mm"
     * @param {Number} msec
     */
    getDate(msec) {
      const date = new Date(msec);
      const hours = this.addZero(date.getHours());
      const minutes = this.addZero(date.getMinutes());

      return `${hours}:${minutes}`;
    },

    /**
     * @param {Number} int
     */
    addZero(int) {
      return int < 10 ? `0${int}` : int;
    },
  },
};
</script>

<style lang="postcss">
.step_time__container {
  position: relative;
  z-index: 1;
}

.step_time__element {
  position: absolute;
}

.step_time__element:last-child {
  transform: translate(-100%, 0);
}

.step_time__element > .step_time__label {
  font-size: 10px;
  padding-top: 10px;
  width: 40px;
  word-wrap: none;
  transform: translate(-16.5px, 0);
  color: #eee;
}

.step_time__element:first-child > .step_time__label {
  transform: translate(5px, 0);
}

.step_time__element:last-child > .step_time__label {
  transform: translate(-40px, 0);
}

.step_time__element--full {
  height: 10px;
  width: 2px;
  background-color: #bdbdbd;
}

.step_time__element--halt {
  height: 6px;
  width: 2px;
  background-color: #757575;
}
</style>
